import type { select } from '@ps/web-core-store';

import type { Game, Speed, Structure } from '@swf/generated/graphql/poker/MTT/schemas';
import type {
  FilterName,
  FilterOptionBase,
  FilterOptionBuyIn,
  FilterOptionGame,
  FilterOptionSpeed,
  FilterOptionTableSize
} from '@swf/poker';

export enum ModalRoutes {
  MobileFiltersScreen = '/mtt/mobile-filters-screen',
  MobileSidecarScreen = '/mtt/sidecar-screen'
}

export type BuyInFilterOptionValue = Exclude<
  FilterOptionBuyIn,
  FilterOptionBuyIn.Custom | FilterOptionBuyIn.Starscoin
>;

export type CustomRangeBuyIn = number[];

export type CustomRangePayload = object | CustomRangeBuyIn;

export type PlayMode = ReturnType<typeof select.currency.getPlayMode>;

export interface FiltersBuyInValue {
  minimum: number;
  maximum: number;
}

export type FilterOptionVariableMap = {
  [FilterName.Games]: {
    [K in FilterOptionGame]: Game;
  };
  [FilterName.BuyIn]: {
    [K in Exclude<FilterOptionBuyIn, FilterOptionBuyIn.Starscoin | FilterOptionBuyIn.Custom>]: {
      RM: FiltersBuyInValue;
      PM: FiltersBuyInValue;
    };
  };
  [FilterName.TableSize]: {
    [K in FilterOptionTableSize]: number[];
  };
  [FilterName.Speed]: { [K in FilterOptionSpeed]: Speed };
} & { structure: Partial<{ [K in FilterOptionGame]: Structure }> };

export type ActiveUiFilters = {
  [K in FilterName]?: FilterOptionBase[];
};

export interface CustomFilterTypes {
  includeTerms: string[];
  excludeTerms: string[];
}
